export default __webpack_public_path__ + "static/media/wire.5e1bc7aa.png";